// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__JrqjH","originalValue":"styles_originalValue__D3kB7","requestedValue":"styles_requestedValue__TffAh","list":"styles_list__Wu1hb"};